export const mandatoryTag = '<span style="color:#B30F16">*</span> '
